<template>
<select v-model="value_" @change="onChange($event)" :class="{search: this.search}" :id="id" :name="name">
  <slot></slot>
  <option v-if="options" v-for="each in options" :key="`${keyPrefix}${each.value}`" :value="each.value">{{ each.label }}</option>

</select>
</template>

<script>
export default {
    data: function() {
        return {
            value_: null,
        };
    },
    props: {
        value: {
            required: true,
        },
        default: {
            required: false
        },
        placeholder: {
            required: false,
            type: String
        },
        options: {
            required: false,
            type: Array,
            default: function() {
                return [];
            }
        },
        maxSize: {
            required: false,
            type: Number,
        },
        clearAtEmpty: {
            required: false,
            type: Boolean,
            default: true
        },
        search: {
            required: false,
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            required: false
        },
        name: {
            type: String,
            required: false
        },
        keyPrefix: {
            required: false,
            type: String,
            default: ''
        }
    },
    created: function() {
        this.value_ = this.value || this.default;
        if (!this.value_ && this.maxSize) {
            if (!this.value) {
                this.value_ = [];
            } else if (!_.isArray(this.value_)) {
                this.value_ = [this.value_];
            }
        }
    },
    mounted: function() {
        if (this.maxSize) {
            $(this.$el).attr('multiple', '');
        }
        this._initDropdown();
        if (this.value_ == null || this.value_ === '') {
            $(this.$el).dropdown('clear');
        }
        this.$watch(function() {
            return this.value;
        }, function() {
            this._setValue(this.value, false);
        });

        // iPhoneでのみ初回変更時のonChangeイベントが発火しないので強引に対処
        var isIos = /iP(hone|ad|od)/.test(window.navigator.userAgent);
        isIos && $('.menu .item', $(this.$el).parent()).one('click', function(event) {
            $('.menu .item', $(this.$el).parent()).off();
            this._setValue($(event.target).data('value'));
            this.onChange();
        }.bind(this));
    },
    methods: {
        _getDropdownSettings: function() {
            var settings = {};
            if (this.placeholder) {
                settings.placeholder = this.placeholder;
            }
            if (this.maxSize) {
                if (this.maxSize >= 0) {
                    settings.maxSelections = this.maxSize;
                }
            }
            return settings;
        },
        _initDropdown: function() {
            $(this.$el).dropdown(this._getDropdownSettings());
        },
        _destroyDropdown: function() {
            if ($(this.$el).data('moduleDropdown')) {
                $(this.$el).dropdown('destroy');
            }
        },
        onChange: function() {
            // undefined で更新してしまうとフィールド自体が消えてしまうので null で更新
            if (this.value_ === undefined) {
                this.value_ = null;
            }
            this.$emit('input', this.value_);
            this.$emit('change', this.value_);
        },
        _setValue: function(value, opt_emitChange) {
            this.value_ = value;
            if (value == null) {
                $(this.$el).dropdown('clear');
            } else if (value === '') {
                var emptyOption = _.filter(this.options, function(each) {
                    return each.value === '';
                });
                if (emptyOption.length > 1 || this.clearAtEmpty) {
                    $(this.$el).dropdown('clear');
                } else {
                    $(this.$el).dropdown('restore defaults');
                }
            } else {
                if (_.isArray(value)) {
                    if (_.isEmpty(value)) {
                        $(this.$el).dropdown('clear');
                    } else {
                        _.forEach(value, function(each) {
                            $(this.$el).dropdown('set selected', each);
                        }.bind(this));
                    }
                } else {
                    $(this.$el).dropdown('set selected', value);
                }
            }

            this.$emit('input', value);
            opt_emitChange && this.$emit('change', value);
        },
        setOptions: function(options) {
            this._destroyDropdown();
            this.clearArray(this.options);
            options.forEach(function(each) {
                this.options.push(each);
            }.bind(this));
            this.$nextTick(function() {
                this._initDropdown();
                this._setValue(this.value, false);
            }.bind(this));
        }
    },
};
</script>;
